<template>
  <q-header bordered class="bg-white text-grey-8" height-hint="58">
    <q-toolbar>
      <div class="menu-toggle-logo">
        <q-btn
          v-if="isGranted('VIEW_CLIENTS')"
          icon="fa fa-bars"
          aria-label="Menu"
          @click="$emit('toggle')"
          flat dense round
        />
        <q-btn flat no-caps no-wrap class="q-ml-xs" v-if="$q.screen.gt.sm">
          <q-toolbar-title shrink>
            <router-link
              :to="{name: 'dashboard'}"
              class="q-link text-weight-bold text-primary"
            >
              Private Footprint
            </router-link>
          </q-toolbar-title>
        </q-btn>
      </div>

      <div
        v-if="isGranted('VIEW_ACTIVE_ACCOUNT')"
        class="flex items-center"
        style="align-self: stretch"
      >
        <active-account v-model="account" class="full-height" />
        <q-btn
          v-if="account"
          icon="fa fa-cog"
          :to="`/admin/accounts/${accountId}/users`"
          title="Admin"
          flat
          stretch
        />
        <q-separator vertical inset class="on-left" />
      </div>

      <navigation />

      <q-space />

      <div
        v-if="isCustomer && isGranted('VIEW_CLIENTS')"
        class="q-mx-md xs-hide sm-hide md-hide"
        style="flex-grow: 3"
      >
        <select-search-user-client @change="selectClient"/>
      </div>

      <q-space />

      <div class="q-gutter-sm row items-center no-wrap">
        <social-accounts-status
          v-if="isGranted('VIEW_CLIENTS') && accountId"
          :account-id="accountId"
        />
        <resources-dropdown v-if="isGranted('VIEW_RESOURCES')" />
        <support-btn flat rounded />
        <user-dropdown />
        <user-notifications-btn />
      </div>
    </q-toolbar>
  </q-header>
</template>

<style lang="scss">
@import '../styles/quasar.variables';

.menu-toggle-logo {
  @media screen and (min-width: $breakpoint-md-min) {
    width: 288px;
  }
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import { UserClient } from '@/type';
import recognition from '@/auth/recognition';
import isGranted from '@/auth/isGranted';
import SocialAccountsStatus from '@/social/account/status/AccountsStatus.vue';
import ActiveAccount from '@/router/ActiveAccount.vue';
import { Account } from '@/iam/types';
import SupportBtn from '@/support/SupportBtn.vue';
import SelectSearchUserClient from '../user-client/SelectSearchUserClient.vue';
import ResourcesDropdown from '../resources/ResourcesDropdown.vue';
import UserDropdown from '../auth/UserDropdown.vue';
import UserNotificationsBtn from '../user-notification/UserNotificationsBtn.vue';
import Navigation from '../router/Navigation.vue';

interface Data {
  account: Account|undefined
}

export default defineComponent({
  emits: ['toggle'],
  components: {
    SupportBtn,
    ActiveAccount,
    SocialAccountsStatus,
    'select-search-user-client': SelectSearchUserClient,
    'resources-dropdown': ResourcesDropdown,
    'user-notifications-btn': UserNotificationsBtn,
    UserDropdown,
    Navigation,
  },
  data(): Data {
    return {
      account: undefined,
    };
  },
  computed: {
    accountId(): number|null {
      return this.account ? this.account.id : null;
    },
    isCustomer(): boolean {
      return recognition.isCustomer();
    },
  },
  methods: {
    isGranted,
    selectClient(userClient: UserClient) {
      this.$router.push(`/clients/${userClient.client.id}`);
    },
  },
});
</script>
